export const leadershipMembers = [
  {
    name: 'Jugal Anchalia',
    title: 'Co-founder & CEO',
    image: '/about-us/jugal.png',
    linkedIn: 'https://www.linkedin.com/in/jugal-anchalia-0a2ab220/'
  },
  {
    name: 'Abhishek Kumar',
    title: 'Co-founder & CPO',
    image: '/about-us/abhishek.png',
    linkedIn: 'https://www.linkedin.com/in/abhishek-kumar-636aa71b/'
  }
];

export const investors = [
  {
    name: 'Better',
    logo: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/Better.jpg'
  },
  {
    name: 'Titan Capital',
    logo: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/Titan+capital.jpg'
  },
  {
    name: '8i Ventures',
    logo: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/8I.jpg'
  }
];

export const careerImages = [
  {
    src: '/about-us/team-1.png',
    alt: 'Team collaboration'
  },
  {
    src: '/about-us/team-2.png',
    alt: 'Office culture'
  },
  {
    src: '/about-us/team-3.png',
    alt: 'Team building'
  },
  {
    src: '/about-us/team-7.png',
    alt: 'Work environment'
  }
];

export const recognitionBadges = [
  {
    src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/G2+leader.jpg",
    alt: "G2 Leader Winter 2025",
  },
  {
    src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/G2+momentum+leader.jpg",
    alt: "G2 Momentum Leader Fall 2024",
  },
  {
    src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/G2+Most+implemented.jpg",
    alt: "G2 Most Implementable Winter 2025",
  },
  {
    src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/G2+Best+Est.+ROI.jpg",
    alt: "G2 Best ROI Winter 2025",
  },
];

export const aboutData = {
  hero: {
    title: "Fast, Scalable, and Built to Evolve with Your Business",
    subtext: "Traditional integrations are slow, fragmented, and hinder growth. Cobalt is changing that. A next-gen integration platform with 1,000+ connectors and AI-driven automation—redefining how businesses integrate, operate, and scale."
  },
  leadership: {
    title: "Leadership team",
    description: "We have obsessed about this problem for years and solved it at world-class scales"
  },
  investors: {
    title: "Supported by World-Class Investors",
    description: "We are privileged to be backed by visionary investors who share our commitment to transforming the future of embedded iPaaS and SaaS integrations."
  },
  careers: {
    tag: "Careers",
    title: "Cobalt is growing",
    description: "We're building a dynamic environment where every team member has the power to innovate, collaborate, and drive real change. If you're ready to be at the forefront of technology—transforming complex integrations into seamless, scalable solutions—your future starts here. ",
    buttonText: "Join Us",
    buttonHref: "/careers"
  },
  recognition: {
    tag: "REVIEWS",
    title: "Recognized Excellence in Embedded iPaaS",
    description: "Powering next-generation startups and established companies"
  },
  caseStudy: {
    title: "OvationCXM Supercharged Integration Efficiency with Cobalt",
    description: "Cobalt slashed our dev time 6x and cut TCO by 53%. What once took months now takes hours—letting us focus on exceptional customer experiences.",
    personName: "Prayas Tiwari",
    personTitle: "Senior Product Manager",
    buttonText: "Read case study",
    buttonUrl: "https://gocobalt.io/case-studies/how-ovationcxm-transformed-integration-efficiency-with-cobalt/",
    imageSrc: "/about-us/ovation-cobalt.jpg",
    imageAlt: "OvationCXM and Cobalt integration"
  },
  cta: {
    title: "The future of software is seamlessly Integrated",
    description: "Be ready with Cobalt's embedded integration platform",
    cta: {
      text: "Get Started ",
      href: "/sign-up",
      secondary: {
        text: "Sign-in",
        href: "/signin"
      }
    }
  }
};